/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable import/no-extraneous-dependencies -- requried for signature */
import React, { useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import SignaturePad from 'react-signature-canvas';
import { localize } from '@saviynt/common';
import {
  AlertBanner,
  Button,
  Checkbox,
  Icon,
  InlineMessage,
  InputField,
  Link,
  TabContent,
  TabGroup,
  TabItem,
  Typography,
  Upload,
  useUploadFile,
} from '@saviynt/design-system';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import {
  SCREEN_SIZE_MOBILE_XLARGE,
  SCREEN_WIDTH_QUERIES,
} from '../../../../utils/constant';
import { useInvertedLocalize } from '../../../../utils/localization';
import { getMessageKey, scrollToPosition } from '../../../../utils/utils';
import AriaErrors from '../../../AriaErrors';
import CertsModalCommentBox, {
  useCertsModalCommentErrors,
} from '../../../CertsModalCommentBox';

import {
  ACTIONKEY_FOR_PREDEFINED_COMMENTS,
  EMPTY_TEXT,
  MINIMUM_LENGTH_OF_COMMENT,
  SIGNATURE_ALERT_COUNT_AGREE_BTN,
  SIGNATURE_ALERT_COUNT_COMMENT,
  SIGNATURE_ALERT_COUNT_SIGNATURE,
  SIGNATURE_ALERT_COUNT_USERNAME,
  SIGNATURE_TAB_DRAW,
  SIGNATURE_TAB_PASSWORD,
  SIGNATURE_TAB_TYPE,
  SIGNATURE_TAB_UPLOAD,
  SIGNATURE_TNC_DESCRIPTION,
  TRANSITION_TIMEOUT,
} from './constant';
import { invertedMessages } from './messages';
import CONFIGDATA from './mockData';
import { blobToBase64, manageAlertFields } from './utils';

import './Step2.css';

function Step2({
  isModalOpen,
  firstStep,
  configData,
  isAlertActive,
  setIsAlertActive,
  setDataForSubmitAction,
}) {
  const intl = useIntl();
  const l = useInvertedLocalize(invertedMessages);
  const [isESignature, setIsESignature] = useState(false);
  const [isCommentEnabled, setIsCommentEnabled] = useState(false);
  const [isPrimaryCertifier, setIsPrimaryCertifier] = useState(true);
  const [step2CommentData, setStep2CommentData] = useState({
    commentDescription: '',
    predefComments: [],
    isCommentApplied: false,
    showAlert: false,
  });
  const [step2SignatureData, setStep2SignatureData] = useState({
    userAttribute: '',
    enableloginSignature: '',
    noOfTries: '',
    predefComments: [],
    userAttributeValue: '',
    isAgreeChecked: false,
    commentDescription: '',
    isCommentApplied: false,
    eSignatureData: '',
    eSignatureTab: '',
    showAlert: false,
    alertFields: [],
  });
  const step2BodyWrapperRef = useRef(null);
  const signaturePadDraw = useRef('signature_pad_draw');
  const signatureBoxRef = useRef(null);

  const { messages } = useSelector((state) => state?.user);
  const {
    core: { predefinedComments },
    global: { mediaQueryValue },
    reviewAndSubmit: { isSubmittingReviewAndSubmit },
  } = useSelector((state) => state?.certifications?.details);

  const mobileLargeQuery = SCREEN_WIDTH_QUERIES.find(
    (item) => item.label === SCREEN_SIZE_MOBILE_XLARGE
  );
  const isMobileXlargeWidth = mobileLargeQuery.value <= mediaQueryValue;

  const {
    uploadedFiles,
    handleFileSelect,
    handleFileDelete,
    handleFileReupload,
    reuploadFileName,
    hasAnyUploadErrors,
  } = useUploadFile();

  const shouldShowStep2ForComment = Boolean(isPrimaryCertifier && isESignature);
  const signatureCommentErrors = useCertsModalCommentErrors(
    step2SignatureData.commentDescription
  );
  const noSigCommentErrors = useCertsModalCommentErrors(
    step2CommentData.commentDescription
  );
  const shouldShowAlertForUserNameForSignature = Boolean(
    step2SignatureData.showAlert &&
      step2SignatureData.userAttributeValue?.trim().length === 0
  );
  const shouldShowAlertForESignatureData = Boolean(
    step2SignatureData.showAlert &&
      step2SignatureData.eSignatureData?.trim().length === 0
  );
  const shouldDisabledClearBtnForESig = Boolean(
    step2SignatureData.eSignatureData?.trim().length === 0 ||
      isSubmittingReviewAndSubmit
  );
  const shouldShowAlertForTncForSignature = Boolean(
    step2SignatureData.showAlert && !step2SignatureData.isAgreeChecked
  );
  const shouldShowAlertForCommentForSignature = Boolean(
    step2SignatureData.showAlert &&
      step2SignatureData.commentDescription?.length <= MINIMUM_LENGTH_OF_COMMENT
  );

  const reviewAndSubmitModalBodyStep2 = classnames(
    'ReviewAndSubmitModal-bodyStep2Wrapper',
    isESignature && 'ReviewAndSubmitModal-bodyStep2Wrapper--withESignature'
  );

  useEffect(() => {
    if (firstStep) {
      document.body.classList.remove('Carousel--isOpen--bodyScrollLock');

      return undefined;
    }

    document.body.classList.add('Carousel--isOpen--bodyScrollLock');

    const focusCloseButton = () => {
      const currentCloseButton = document.getElementById(
        'modalCloseButton-true'
      );

      currentCloseButton?.focus();
    };

    const focusTimeoutId = setTimeout(focusCloseButton, TRANSITION_TIMEOUT);

    return () => {
      clearTimeout(focusTimeoutId);
      document.body.classList.remove('Carousel--isOpen--bodyScrollLock');
    };
  }, [firstStep]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      scrollToPosition(step2BodyWrapperRef, 0);
    }, TRANSITION_TIMEOUT);

    return () => clearTimeout(timeoutId);
  }, [firstStep, isModalOpen]);

  useEffect(() => {
    if (isModalOpen) {
      setStep2CommentData({
        ...step2CommentData,
        commentDescription: '',
        showAlert: false,
      });
      setStep2SignatureData({
        ...step2SignatureData,
        userAttributeValue: '',
        eSignatureData: '',
        isAgreeChecked: false,
        commentDescription: '',
        eSignatureTab:
          step2SignatureData.enableloginSignature === '1'
            ? SIGNATURE_TAB_PASSWORD
            : SIGNATURE_TAB_TYPE,
        showAlert: false,
        alertFields: [],
      });
    }
  }, [isModalOpen]);

  useEffect(() => {
    if (configData) {
      setIsESignature(configData?.withESignature);
      setIsCommentEnabled(configData?.isCommentEnabled);
      setIsPrimaryCertifier(configData?.primaryCertifier);
      setStep2CommentData((prev) => ({
        ...prev,
        predefComments: configData?.step2Data?.predefComments,
      }));
      setStep2SignatureData((prev) => ({
        ...prev,
        enableloginSignature: configData?.enableloginSignature,
        userAttribute: configData?.userAttribute,
        noOfTries: configData?.noOfTries,
        eSignatureTab:
          configData?.enableloginSignature === '1'
            ? SIGNATURE_TAB_PASSWORD
            : SIGNATURE_TAB_TYPE,
        predefComments: configData?.step2Data?.predefComments,
      }));
    }
  }, [configData]);

  useEffect(() => {
    if (isESignature && isAlertActive && isPrimaryCertifier) {
      const tempAlertFields = [];

      if (step2SignatureData.userAttributeValue.trim().length === 0) {
        tempAlertFields.push(SIGNATURE_ALERT_COUNT_USERNAME);
      }

      if (step2SignatureData.eSignatureData.trim().length === 0) {
        tempAlertFields.push(SIGNATURE_ALERT_COUNT_SIGNATURE);
      }

      if (!step2SignatureData.isAgreeChecked) {
        tempAlertFields.push(SIGNATURE_ALERT_COUNT_AGREE_BTN);
      }

      if (
        isCommentEnabled &&
        step2SignatureData.commentDescription.trim().length <=
          MINIMUM_LENGTH_OF_COMMENT
      ) {
        tempAlertFields.push(SIGNATURE_ALERT_COUNT_COMMENT);
      }

      setStep2SignatureData({
        ...step2SignatureData,
        alertFields: tempAlertFields,
        showAlert: isAlertActive,
      });
    }

    if (
      isCommentEnabled &&
      (!isESignature || !isPrimaryCertifier) &&
      isAlertActive
    ) {
      setIsAlertActive(false);
      setStep2CommentData({
        ...step2CommentData,
        showAlert:
          isAlertActive &&
          step2CommentData.commentDescription.trim().length <=
            MINIMUM_LENGTH_OF_COMMENT,
      });
    }
  }, [isAlertActive]);

  useEffect(() => {
    setDataForSubmitAction({
      isESignature,
      isPrimaryCertifier,
      isCommentEnabled,
      step2CommentData,
      step2SignatureData,
    });
  }, [isESignature, step2CommentData, step2SignatureData]);

  // Without Signature Functions
  const handleCommentDescription = (text) => {
    setStep2CommentData({
      ...step2CommentData,
      commentDescription: text,
      showAlert:
        text.length <= MINIMUM_LENGTH_OF_COMMENT
          ? step2CommentData.showAlert
          : false,
    });
  };

  // With Signature functions
  const handleSignatureUserName = (text) => {
    setStep2SignatureData({
      ...step2SignatureData,
      userAttributeValue: text,
      alertFields: manageAlertFields(
        step2SignatureData.alertFields,
        SIGNATURE_ALERT_COUNT_USERNAME,
        text.trim().length === 0
      ),
    });
  };

  // ESignature Box
  const [tabTypeData, setTabTypeData] = useState('');

  useEffect(() => {
    if (typeof signaturePadDraw?.current === 'object') {
      signaturePadDraw?.current?.on();
    }

    return () => {
      if (typeof signaturePadDraw?.current === 'object') {
        signaturePadDraw?.current?.off();
      }
    };
  }, []);

  const handleSignatureESignTab = (tab) => {
    setTabTypeData('');

    if (
      signaturePadDraw.current &&
      typeof signaturePadDraw.current === 'object' &&
      typeof signaturePadDraw.current.clear !== 'undefined'
    ) {
      signaturePadDraw?.current?.clear();
    }

    uploadedFiles.length = 0;

    setStep2SignatureData({
      ...step2SignatureData,
      eSignatureData: '',
      eSignatureTab: tab,
      alertFields: manageAlertFields(
        step2SignatureData.alertFields,
        SIGNATURE_ALERT_COUNT_SIGNATURE,
        true
      ),
    });
  };

  const handleSignatureESignTypeAndPassword = (event) => {
    setTabTypeData(event.target.value);
    setStep2SignatureData({
      ...step2SignatureData,
      eSignatureData: event.target.value,
      alertFields: manageAlertFields(
        step2SignatureData.alertFields,
        SIGNATURE_ALERT_COUNT_SIGNATURE,
        event.target.value.length === 0
      ),
    });
  };

  const handleSignatureESignDrawOnBegin = () => {
    setStep2SignatureData({
      ...step2SignatureData,
      eSignatureData: 'signature_started',
      alertFields: manageAlertFields(
        step2SignatureData.alertFields,
        SIGNATURE_ALERT_COUNT_SIGNATURE,
        false
      ),
    });
  };

  const handleSignatureESignDrawOnEnd = () => {
    setStep2SignatureData({
      ...step2SignatureData,
      eSignatureData: signaturePadDraw?.current?.toDataURL('image/svg', 1.0),
      alertFields: manageAlertFields(
        step2SignatureData.alertFields,
        SIGNATURE_ALERT_COUNT_SIGNATURE,
        false
      ),
    });
  };

  useEffect(() => {
    const shouldSetData = Boolean(
      uploadedFiles.length > 0 &&
        step2SignatureData.eSignatureTab === SIGNATURE_TAB_UPLOAD &&
        !hasAnyUploadErrors
    );

    if (shouldSetData) {
      blobToBase64(uploadedFiles[0].file).then((base64Text) => {
        setStep2SignatureData({
          ...step2SignatureData,
          eSignatureData: base64Text,
          alertFields: manageAlertFields(
            step2SignatureData.alertFields,
            SIGNATURE_ALERT_COUNT_SIGNATURE,
            base64Text.trim().length === 0
          ),
        });
      });
    }
  }, [uploadedFiles]);

  const handleSignatureClearBtn = () => {
    if (
      step2SignatureData.eSignatureTab === SIGNATURE_TAB_TYPE ||
      step2SignatureData.eSignatureTab === SIGNATURE_TAB_PASSWORD
    ) {
      setTabTypeData('');
    }

    if (step2SignatureData.eSignatureTab === SIGNATURE_TAB_DRAW) {
      signaturePadDraw?.current?.clear();
    }

    if (step2SignatureData.eSignatureTab === SIGNATURE_TAB_UPLOAD) {
      uploadedFiles.length = 0;
    }

    setStep2SignatureData({
      ...step2SignatureData,
      eSignatureData: '',
      alertFields: manageAlertFields(
        step2SignatureData.alertFields,
        SIGNATURE_ALERT_COUNT_SIGNATURE,
        true
      ),
    });
  };

  // Rest
  const handleAgreeCheckBox = () => {
    setStep2SignatureData({
      ...step2SignatureData,
      isAgreeChecked: !step2SignatureData.isAgreeChecked,
      alertFields: manageAlertFields(
        step2SignatureData.alertFields,
        SIGNATURE_ALERT_COUNT_AGREE_BTN,
        step2SignatureData.isAgreeChecked
      ),
    });
  };

  const handleSignatureComment = (text) => {
    setStep2SignatureData({
      ...step2SignatureData,
      commentDescription: text,
      alertFields: manageAlertFields(
        step2SignatureData.alertFields,
        SIGNATURE_ALERT_COUNT_COMMENT,
        text?.length === 0
      ),
    });
  };

  // Alert box function
  const handleAlertClose = () => {
    setIsAlertActive(false);

    if (isESignature && isPrimaryCertifier) {
      setStep2SignatureData({
        ...step2SignatureData,
        showAlert: false,
        alertFields: [],
      });
    }

    if (!isESignature || !isPrimaryCertifier) {
      setStep2CommentData({
        ...step2CommentData,
        showAlert: false,
      });
    }
  };

  const getAlertBoxTitle = () =>
    shouldShowStep2ForComment
      ? l(`Required fields ({count}) are missing.`, {
          count: step2SignatureData.alertFields.length,
        })
      : l('Required field is missing.');

  const renderStep2WithOutSignature = () => {
    if (isCommentEnabled)
      return (
        <CertsModalCommentBox
          isDisabled={isSubmittingReviewAndSubmit}
          defaultComments={
            predefinedComments[ACTIONKEY_FOR_PREDEFINED_COMMENTS] ||
            step2CommentData?.predefComments
          }
          showAlert={step2CommentData.showAlert}
          onChange={handleCommentDescription}
          allowEditPredefinedComments={
            predefinedComments?.allowEditPredefinedComments
          }
        />
      );

    return null;
  };

  // With Esignature
  const renderTabsForStep2SignatureBox = () => {
    if (step2SignatureData.enableloginSignature === '1') {
      return (
        <TabGroup
          moreContainerRef={signatureBoxRef}
          className='ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabGroup'
          value={step2SignatureData.eSignatureTab}
          onChange={handleSignatureESignTab}>
          <span className='ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabGroupSpacer--before' />
          <TabItem
            label={l('Password')}
            value={SIGNATURE_TAB_PASSWORD}
            icon={<Icon kind='Password' size='medium' color='neutral-600' />}
          />
          <span className='ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabGroupSpacer--after' />
        </TabGroup>
      );
    }

    if (step2SignatureData.enableloginSignature === '0') {
      return (
        <TabGroup
          moreContainerRef={signatureBoxRef}
          className='ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabGroup'
          value={step2SignatureData.eSignatureTab}
          onChange={handleSignatureESignTab}>
          <span className='ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabGroupSpacer--before' />
          <TabItem
            label={l('Type')}
            value={SIGNATURE_TAB_TYPE}
            icon={<Icon kind='KeyBoard' size='medium' color='neutral-600' />}
          />
          <TabItem
            label={l('Draw')}
            value={SIGNATURE_TAB_DRAW}
            icon={<Icon kind='Edit' size='medium' color='neutral-600' />}
          />
          <TabItem
            label={l('Upload')}
            value={SIGNATURE_TAB_UPLOAD}
            icon={
              <Icon kind='ImageOutline' size='medium' color='neutral-600' />
            }
          />
          <span className='ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabGroupSpacer--after' />
        </TabGroup>
      );
    }

    return (
      <TabGroup
        moreContainerRef={signatureBoxRef}
        className='ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabGroup'
        value={step2SignatureData.eSignatureTab}
        onChange={handleSignatureESignTab}>
        <span className='ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabGroupSpacer--before' />
        <TabItem
          label={l('Type')}
          value={SIGNATURE_TAB_TYPE}
          icon={<Icon kind='KeyBoard' size='medium' color='neutral-600' />}
        />
        <span className='ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabGroupSpacer--after' />
      </TabGroup>
    );
  };

  const renderStep2WithSignature = () => (
    <>
      <InputField
        name='basic'
        placeholder={l(
          `Please enter {attribute} if applicable else enter N/A`,
          {
            attribute:
              messages[step2SignatureData?.userAttribute] ||
              localize(
                intl,
                getMessageKey(step2SignatureData?.userAttribute?.split('.')[0])
              ),
          }
        )}
        isDisabled={isSubmittingReviewAndSubmit}
        label={
          <Typography kind='label' mobile='h4-d' htmlFor='Critical'>
            {/* eslint-disable-next-line react/jsx-one-expression-per-line */}
            {l('Enter')}
            {messages[step2SignatureData?.userAttribute] ||
              localize(
                intl,
                getMessageKey(step2SignatureData?.userAttribute?.split('.')[0])
              )}
          </Typography>
        }
        value={step2SignatureData.userAttributeValue}
        setValue={handleSignatureUserName}
        kind='singleline'
        isRequired
        isCritical={shouldShowAlertForUserNameForSignature}
        CriticalHelperText={
          <InlineMessage kind='missingRequiredField' size='small' />
        }
      />
      <div className='ReviewAndSubmitModal-bodyStep2WrapperSignatureESig'>
        <div className='ReviewAndSubmitModal-bodyStep2WrapperSignatureESigBox'>
          <InputField
            name='basic'
            placeholder=''
            isDisabled={isSubmittingReviewAndSubmit}
            value={step2SignatureData.eSignatureData}
            label={
              <Typography kind='label' mobile='h4-d' htmlFor='Critical'>
                {l('E-Signature')}
              </Typography>
            }
            kind='multiline'
            isRequired
            isCritical={
              shouldShowAlertForESignatureData ||
              step2SignatureData.eSignatureData === ''
            }
            CriticalHelperText={
              <InlineMessage
                text={l('This required field is incomplete')}
                colorTheme='critical'
                size='small'
                leftIcon={
                  <Icon kind='AlertCriticalFilled' color='critical-700' />
                }
              />
            }
          />
        </div>
        <div
          ref={signatureBoxRef}
          className='ReviewAndSubmitModal-bodyStep2WrapperSignaturePad'>
          {renderTabsForStep2SignatureBox()}
          <TabContent
            className='ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabContent'
            value={step2SignatureData.eSignatureTab}
            tabValue={SIGNATURE_TAB_PASSWORD}>
            <div className='ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabContentBgText'>
              {l('Type your password')}
            </div>
            <input
              type='password'
              maxLength='32'
              value={tabTypeData}
              onChange={handleSignatureESignTypeAndPassword}
              className={`ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabContentInput ${
                tabTypeData.length > 0 ? 'filled' : ''
              }`}
            />
          </TabContent>
          <TabContent
            className='ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabContent'
            value={step2SignatureData.eSignatureTab}
            tabValue={SIGNATURE_TAB_TYPE}>
            <div className='ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabContentBgText'>
              {l('Type your name to sign')}
            </div>
            <input
              type='text'
              maxLength='32'
              value={tabTypeData}
              onChange={handleSignatureESignTypeAndPassword}
              className={`ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabContentInput ${
                tabTypeData.length > 0 ? 'filled' : ''
              }`}
            />
          </TabContent>
          <TabContent
            className='ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabContent'
            value={step2SignatureData.eSignatureTab}
            tabValue={SIGNATURE_TAB_DRAW}>
            <SignaturePad
              ref={signaturePadDraw}
              onBegin={handleSignatureESignDrawOnBegin}
              onEnd={handleSignatureESignDrawOnEnd}
              canvasProps={{
                className: `ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabContentDraw ${
                  step2SignatureData.eSignatureData.length > 0
                    ? 'hideBgText'
                    : ''
                }`,
              }}
            />
            <div className='ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabContentBgText'>
              {l('Draw your signature')}
            </div>
          </TabContent>
          <TabContent
            className='ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabContent'
            value={step2SignatureData.eSignatureTab}
            tabValue={SIGNATURE_TAB_UPLOAD}>
            <Upload
              kind='button'
              isMultiple={false}
              onFileSelect={handleFileSelect}
              onFileDelete={handleFileDelete}
              onFileReupload={handleFileReupload}
              uploadedFiles={uploadedFiles}
              acceptTypes='.pdf,.png,.jpeg,.jpg'
              reuploadFileName={reuploadFileName}
              isMaxNumberUploaded={uploadedFiles.length === 1}
              isMaxTotalSizeReached={uploadedFiles.length === 1}
              maxFileSize={10}
              maxTotalFileSize={10}
              helperText=''
              className='ReviewAndSubmitModal-bodyStep2WrapperSignaturePadTabContentUpload'
            />
          </TabContent>
        </div>
        <Button
          type='button'
          className={`ReviewAndSubmitModal-bodyStep2WrapperSignaturePadClearBtn ${
            shouldShowAlertForESignatureData ? '' : 'noCommentsPresent'
          }`}
          kind={shouldDisabledClearBtnForESig ? 'filled' : 'outlined'}
          isDisabled={shouldDisabledClearBtnForESig}
          onClick={handleSignatureClearBtn}
          size='small'>
          {l('Clear')}
        </Button>
      </div>
      <div className='ReviewAndSubmitModal-bodyStep2WrapperSignatureTnC'>
        <Typography kind='label' mobile='h4-d' htmlFor='Disabled'>
          {l('Terms and Conditions')}
        </Typography>
        <Typography
          kind='body2'
          className='ReviewAndSubmitModal-bodyStep2WrapperSignatureTnCText'>
          {SIGNATURE_TNC_DESCRIPTION}
        </Typography>
        <div className='ReviewAndSubmitModal-bodyStep2WrapperSignatureTnCCheckBox'>
          <InputField
            name='Warning'
            placeholder=''
            isDisabled={isSubmittingReviewAndSubmit}
            label={
              <Checkbox
                isChecked={step2SignatureData.isAgreeChecked}
                onChange={handleAgreeCheckBox}
                label={l('I agree')}
                size='small'
                textPosition='after'
                showHoverEffect
              />
            }
            value={step2SignatureData.isAgreeChecked ? 'TnC' : EMPTY_TEXT}
            kind='singleline'
            isRequired
            isCritical={shouldShowAlertForTncForSignature}
            CriticalHelperText={
              <InlineMessage kind='missingRequiredField' size='small' />
            }
          />
        </div>
      </div>
      {isCommentEnabled && (
        <CertsModalCommentBox
          isDisabled={isSubmittingReviewAndSubmit}
          defaultComments={
            predefinedComments[ACTIONKEY_FOR_PREDEFINED_COMMENTS] ||
            step2SignatureData?.predefComments
          }
          showAlert={shouldShowAlertForCommentForSignature}
          onChange={handleSignatureComment}
          allowEditPredefinedComments={
            predefinedComments?.allowEditPredefinedComments
          }
        />
      )}
    </>
  );

  return (
    <div className={reviewAndSubmitModalBodyStep2} ref={step2BodyWrapperRef}>
      <AlertBanner
        colorTheme='Critical'
        title={getAlertBoxTitle()}
        description=''
        isColonVisible={false}
        isVisible={
          shouldShowStep2ForComment
            ? step2SignatureData.showAlert &&
              step2SignatureData.alertFields.length > 0
            : step2CommentData.showAlert
        }
        onCancel={handleAlertClose}
        LinkComponent={
          isESignature ? (
            <Link
              onClick={() => {
                // url='/route' // TODO: @Sagar, Needs to scroll to ESignature
              }}
              text={l('View')}
              suffixIconKind='ArrowDown'
              color='neutral'
              dataTheme='dark'
            />
          ) : null
        }
        isFloating
        position={
          isMobileXlargeWidth
            ? { type: 'fixed', top: '0.5rem', left: '0', right: '1rem' } // Spacing left not working due to hidden slideing panels
            : { type: 'fixed', top: '0.5rem' }
        }
        className='CertsReviewAndSubmit-alertBanner'
      />
      <AriaErrors
        isCritical={step2SignatureData.showAlert || step2CommentData.showAlert}
        messages={[
          shouldShowAlertForUserNameForSignature && l('Username is required'),
          shouldShowAlertForESignatureData && l('E-Signature is required'),
          shouldShowAlertForTncForSignature &&
            l('Terms and Conditions agreement is required'),
          ...(isCommentEnabled && shouldShowAlertForCommentForSignature
            ? signatureCommentErrors
            : []),
          ...(!shouldShowStep2ForComment ? noSigCommentErrors : []),
        ]}
      />
      {shouldShowStep2ForComment
        ? renderStep2WithSignature()
        : renderStep2WithOutSignature()}
    </div>
  );
}

Step2.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  firstStep: PropTypes.bool.isRequired,
  configData: PropTypes.shape(CONFIGDATA),
  isAlertActive: PropTypes.bool.isRequired,
  setIsAlertActive: PropTypes.func,
  setDataForSubmitAction: PropTypes.func,
};

Step2.defaultProps = {
  configData: {},
  setIsAlertActive: () => {},
  setDataForSubmitAction: () => {},
};

export default Step2;
